export default {
  namespaced: true,
  state: {
    deliveryInfo: {
      id: "",
      recv_name: "",
      recv_phone: "",
      zip: "",
      addr: "",
      msg: "",
      cost: 0,
    }
  },
  mutations: {
    reset(state) {
      state.deliveryInfo = {
        id: "",
        recv_name: "",
        recv_phone: "",
        zip: "",
        addr: "",
        msg: "",
        cost: 0,
      }
    },
    updateDeliveryInfo(state, value = {}) {
      state.deliveryInfo.id = value.id;
      state.deliveryInfo.recv_name = value.name;
      state.deliveryInfo.recv_phone = value.cellphone;
      state.deliveryInfo.zip = value.postalCode;
      state.deliveryInfo.addr = value.formattedAddress;
      state.deliveryInfo.msg = value.message;
    },
    updateDeliveryFee(state, value = 0) {
      state.deliveryInfo.cost = value;
    }
  },
  getters: {
    deliveryInfo(state) {
      return state.deliveryInfo;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/delivery.js